export default __webpack_public_path__ + "2416c30b296c5e0397f3e0e1b09e268e.webp";